export default "__VITE_ASSET__Bon6F3HP__"